import {
    FormControl,
    FormControlLabel,
    FormGroup,
    FormHelperText,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Switch,
    TextField,
} from '@mui/material';
import SelectMemed from './SelectMemed';
import { PriceInputMasked } from '../../../components/masks/PriceInputMasked';

export default ({handleChange, setFieldValue, values, errors}) => {
    return (
        <Grid container spacing={2} mt={1}>
            <Grid item xs={12}>
                <TextField
                    required
                    helperText={errors.name}
                    inputProps={{
                        maxLength: 30,
                    }}
                    onChange={handleChange}
                    value={values.name}
                    fullWidth
                    name="name"
                    label="Nome"
                    error={Boolean(errors.name)}
                />
            </Grid>

            <Grid item xs={12}>
                <TextField
                    error={Boolean(errors.amount)}
                    required
                    helperText={errors.amount}
                    InputProps={{
                        inputComponent: PriceInputMasked,
                    }}
                    onChange={handleChange}
                    value={values.amount}
                    fullWidth
                    name="amount"
                    label="Valor da especialidade"
                    
                />
            </Grid>
            <Grid item xs={12}>
                <SelectMemed
                    required
                    helperText={errors.memedId}
                    inputProps={{
                        maxLength: 30,
                    }}
                    onChange={setFieldValue}
                    value={values.memedId}
                    fullWidth
                    name="memedId"
                    label="ID MEMED"
                />
            </Grid>
            <Grid item xs={12}>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={values.status}
                                name="status"
                                inputProps={{'aria-label': 'controlled'}}
                                onChange={(e, value) => setFieldValue('status', value)}
                            />
                        }
                        label={values.status ? 'Ativo' : 'Inativo'}
                    />
                </FormGroup>
            </Grid>
        </Grid>
    );
};
